import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, Tab, Tabs, Typography } from '@mui/material';

export default function PlatformBillingLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const tab = location.pathname.includes('/platform/billing/invoices') ? 'invoices' : 'profiles';

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Billing
      </Typography>
      <Tabs
        value={tab}
        onChange={(_e, v) => {
          if (v === 'invoices') navigate('/platform/billing/invoices');
          else navigate('/platform/billing/profiles');
        }}
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
      >
        <Tab label="Profiles" value="profiles" />
        <Tab label="Invoices" value="invoices" />
      </Tabs>
      <Outlet />
    </Box>
  );
}
